import React, { useState } from "react";
import {
  AccessType,
  AddUserPermissionResponse,
  GetAPIPermissionsResponse,
} from "../../../models/userPermission.model";
import {
  Box,
  Button,
  Checkbox,
  Grid,
  IconButton,
  InputBase,
  Modal,
  Paper,
  Typography,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import PermisssionCertificateTable from "./PermisssionCertificateTable";
import { CacheProvider, ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material/styles";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import Autocomplate from "../../../components/dropdown/Autocomplate";
import { useMutation } from "react-query";
import { AddUserPermissions } from "../../../services/userPermissions.service";
import SwitchCmp from "../../../components/switch/SwitchCmp";
import TabsEmptyStyle from "./TabsEmptyStyle";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import ClearIcon from "@mui/icons-material/Clear";
import { useHistory } from "react-router-dom";
import { v4 as uuid } from "uuid";
import SearchIcon from "@mui/icons-material/Search";

const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: 500,
  },
  maxWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: 500,
  },

  maxHeight: "70vh",
  minHeight: "30vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  // overflow: "auto",
  // overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "4vh",
  // direction: "ltr",
  borderRadius: "5px",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};
const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});
interface Props {
  userPermissionsList: AddUserPermissionResponse[];
  userPermissionOptions: GetAPIPermissionsResponse[];
  setUpdateGetUserPermissions: any;
  setUserPermissionsList: any;
  setUpdateGetApiPermissions: any;
}

const Certificate = ({
  userPermissionsList,
  userPermissionOptions,
  setUpdateGetUserPermissions,
  setUserPermissionsList,
  setUpdateGetApiPermissions,
}: Props) => {
  const [openModal, setOpenModal] = useState(false);
  const [accessType, setAccessType] = useState<AccessType>("Deny");
  const [
    valueUserPermissionsOptions,
    setValueUserPermissionsOptions,
  ] = useState<number[]>([]);
  const [valueUserPermission, setValueUserPermission] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState("");

  const history = useHistory<{ permissionUserId: number }>();
  const userId =
    history?.location?.state?.permissionUserId !== undefined
      ? history?.location?.state?.permissionUserId
      : Number(window.localStorage.getItem("PermissionUserId"));
  const handleAddCertificate = () => {
    AddUserPermissionsMutate({
      userId: userId,
      permissionIds: valueUserPermissionsOptions,
      accessType: accessType,
    });
  };

  function changeValueUserPemissionOptions(e: any, value: any) {
    setValueUserPermissionsOptions(e);
    setValueUserPermission(value);
  }

  const { mutate: AddUserPermissionsMutate } = useMutation(AddUserPermissions, {
    onSuccess: (data: AddUserPermissionResponse[]) => {
      if (data) {
        setOpenModal(false);
        setUserPermissionsList([...userPermissionsList, ...data]);
        setValueUserPermission([]);
        setValueUserPermissionsOptions([]);
        setUpdateGetApiPermissions(uuid());
      }
    },
    onError: () => {},
  });

  const removeTag = (tagId: number) => {
    setValueUserPermission(
      valueUserPermission.filter((permission) => permission.id !== tagId)
    );
    setValueUserPermissionsOptions(
      valueUserPermissionsOptions.filter((item) => item !== tagId)
    );
  };
  const handleSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value.trim().toLocaleLowerCase());
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12} sx={{ display: "flex", gap: "1" }}>
          <Typography
            onClick={() => setOpenModal(true)}
            color={"#28A745"}
            fontWeight={"bold"}
            padding={"0.5rem"}
            borderRadius={"5px"}
            sx={{
              cursor: "pointer",
              width: "fit-content",
              "&: hover": { color: "#fff", background: "#28A745" },
            }}
          >
            <AddCircleOutlineIcon sx={{ marginLeft: "7px" }} />
            ثبت مجوز اختصاصی
          </Typography>
          <span className="seprator_gray"></span>
          <Paper
            elevation={0}
            style={{
              border: "1px solid #DAE0E4",
              display: "flex",
              borderRadius: "5px",
              height: "35px",
              width: "20vw",
            }}
            square={true}
          >
            <InputBase
              sx={{
                ml: 1,
                flex: 1,
                paddingX: "16px",
                height: "30px !important",
              }}
              placeholder="جستجو"
              onChange={handleSearchInput}
            />

            <IconButton
              type="button"
              sx={{ color: "#9AAFC4" }}
              aria-label="search"
            >
              <SearchIcon />
            </IconButton>
          </Paper>
        </Grid>
        {userPermissionsList.length > 0 ? (
          <Grid item xs={12} marginTop={"1.9vh"} sx={{ background: "#F9FCFE" }}>
            <PermisssionCertificateTable
              userPermissionsList={userPermissionsList}
              setUpdateGetUserPermissions={setUpdateGetUserPermissions}
              searchTerm={searchTerm}
            />
          </Grid>
        ) : (
          <TabsEmptyStyle text="مجوزهای اختصاصی" />
        )}
      </Grid>
      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          setValueUserPermission([]);
          setValueUserPermissionsOptions([]);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="certificate-modal"
      >
        <Box sx={deactiveUserStyle}>
          <Grid
            container
            flexDirection={"column"}
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={"3.8rem"}
          >
            <Grid item>
              <Typography
                component={"p"}
                display={"block"}
                textAlign={"center"}
                fontWeight={"bold"}
                // marginY={"3rem"}
                fontSize={"14px"}
                color={"#1D4A87"}
              >
                افزودن مجوز اختصاصی
              </Typography>
            </Grid>
            <Grid item xs={12} width={"100%"} className="certificate-switch">
              <SwitchCmp
                Label={"مجوز اختصاصی"}
                checked={accessType === "Allow"}
                onChange={(checked: boolean) => {
                  if (checked) {
                    setAccessType("Allow");
                  } else {
                    setAccessType("Deny");
                  }
                }}
                onlabel={"اعطا شود"}
                offlabel={"مسدود شود"}
                colSize="col-lg-6 col-6"
              />
            </Grid>

            <Grid item width={"100%"}>
              <CacheProvider value={cacheRtl}>
                <ThemeProvider theme={theme}>
                  <div dir="rtl">
                    <Autocomplate
                      id="userPermission"
                      name="userPermission"
                      value={valueUserPermissionsOptions}
                      label="انتخاب مجوز"
                      options={userPermissionOptions}
                      onChange={changeValueUserPemissionOptions}
                      changeMultiSelect={changeValueUserPemissionOptions}
                      responseValue={valueUserPermission}
                    />
                  </div>
                </ThemeProvider>
              </CacheProvider>
            </Grid>

            {valueUserPermission.length > 0 && (
              <Box
                sx={{
                  borderTop: "1px solid #CCD1D6",
                  width: "100%",
                  paddingTop: "2rem",
                }}
              >
                <Typography
                  sx={{
                    color: "#1D4A87",
                    marginTop: "10px",
                    fontWeight: "bold",
                    marginBottom: "10px",
                  }}
                >
                  مجوز های اضافه شده
                </Typography>
                <Grid
                  item
                  sx={{ display: "flex", gap: "7px", flexWrap: "wrap" }}
                >
                  {valueUserPermission.map((userPermission) => (
                    <Box
                      sx={{
                        background: "#EDEFEF",
                        padding: "3px 7px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        borderRadius: "5px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {userPermission.title}
                      <Typography
                        sx={{ cursor: "pointer" }}
                        onClick={() => removeTag(userPermission.id)}
                      >
                        <ClearIcon
                          sx={{ color: "#34495E", fontSize: "14px" }}
                        />
                      </Typography>
                    </Box>
                  ))}
                </Grid>
              </Box>
            )}

            <Grid item width={"100%"}>
              <Grid
                container
                flexDirection={"row"}
                justifyContent={"center"}
                gap={"1rem"}
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  maxWidth={"150px !important"}
                >
                  <Button
                    onClick={handleAddCertificate}
                    fullWidth
                    variant="contained"
                    disabled={valueUserPermissionsOptions.length === 0}
                    className={
                      valueUserPermissionsOptions.length === 0
                        ? "btnForm disabledBtn"
                        : "btnForm SuccessDefault"
                    }
                  >
                    ثبت
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  maxWidth={"150px !important"}
                >
                  <Button
                    fullWidth
                    variant="contained"
                    style={{
                      fontSize: "1rem",
                      color: "#fff",
                      height: "40px",
                      background: "#607D8B",
                    }}
                    onClick={() => {
                      setOpenModal(false);
                      setValueUserPermission([]);
                      setValueUserPermissionsOptions([]);
                    }}
                  >
                    بازگشت
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default Certificate;
